import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { AssetSearchComponent } from '@zero/shared/ui-web-components';
import { IconButtonComponent } from '@zero/shared/ui-web-design-system';
import { Asset, InstrumentType } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';
import { OnboardingContainerComponent } from '../../../components/onboarding-container/onboarding-container.component';

@Component({
  imports: [OnboardingContainerComponent, TranslocoPipe, IconButtonComponent, NgTemplateOutlet, RouterLink, AssetSearchComponent],
  templateUrl: './alternative.component.html',
  styleUrl: './alternative.component.scss',
})
export class AlternativeComponent implements OnInit {
  readonly #router = inject(Router);
  readonly #savingsPlanFacade = inject(SavingsPlanFacade);
  readonly #topInstruments = toSignal(this.#savingsPlanFacade.mostChosenSavingPlans$);

  public readonly etfs = computed(() => this.#topInstruments()[InstrumentType.Etf]);
  public readonly stocks = computed(() => this.#topInstruments()[InstrumentType.Share]);
  public readonly createSavingsPlanRoute = commonRoutes.postlogin.onboarding.savingsPlan.create;

  ngOnInit(): void {
    this.#savingsPlanFacade.loadMostChosenSavingplans(true, 5);
  }

  public goBack = () => this.#navigate(commonRoutes.postlogin.onboarding.savingsPlan.favoriteSuggestions);

  public addAsset = (asset: Asset) => {
    asset?.isin && this.#navigate(`${this.createSavingsPlanRoute}/${asset.isin}`);
  };

  readonly #navigate = (route: string) => this.#router.navigateByUrl(route);
}
